export function Card({ children, style }) {
  return <div className="card" style={style}>{children}</div>;
}

export function CardHead({ title, action }) {
  return (
    <div className="card__head">
      <span>{title}</span>
      {action}
    </div>
  );
}

export function Stat({ label, value, sub, tone }) {
  return (
    <div className="card stat">
      <div className="stat__label">{label}</div>
      <div className="stat__value" style={tone ? { color: tone } : undefined}>{value}</div>
      <div className="stat__sub">{sub}</div>
    </div>
  );
}

/* Placeholder for the sections we haven't built out yet. */
export function EmptySection({ title, body }) {
  return (
    <div className="card">
      <div className="empty">
        <div className="empty__title">{title}</div>
        <p className="empty__body">{body}</p>
      </div>
    </div>
  );
}
